import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssCurrencyPage extends ComponentBase {

    protected autocompleteOptions: Array<string> = ['off', 'on'];
    protected iconOptions: Array<string> = ['ui:icons.dollar', 'ui:icons.add', 'ui:icons.phone'];
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////

    ////****************** Example 2 ********************************************////

    protected ex2MinAmount?: number | null = 5;
    protected ex2MaxAmount?: number | null = 10;

    ////****************** Example 3 ********************************************////

    protected ex3Label: string | null = 'Select an Amount';
    protected ex3Icon: string | null = 'ui:icons.dollar';
    protected ex3CurrencyFormat: string | null = '!$#,##0.0000';

}
